import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks';
import { AffiliateOffer } from '#/models/rewards/AffiliateOffer';

import { doGet, doPost, doPut, doDelete, doPostFileUpload, toPaginatedURL } from '../../helpers';

interface AffiliateOffersFilters {
  categories?: string;
  affiliationNetwork?: string;
  searchTerm?: string;
}

export const affiliateOffers = {
  getAll: (pagination: PaginationOptions, filters?: AffiliateOffersFilters) => () => {
    const baseUrl = toPaginatedURL('/affiliate-offers', pagination);
    const extra: string[] = [];
    if (filters?.categories) {
      extra.push(`categories=${encodeURIComponent(filters.categories)}`);
    }
    if (filters?.affiliationNetwork) {
      extra.push(`affiliationNetwork=${encodeURIComponent(filters.affiliationNetwork)}`);
    }
    if (filters?.searchTerm) {
      extra.push(`searchTerm=${encodeURIComponent(filters.searchTerm)}`);
    }
    if (extra.length === 0) {
      return doGet<AffiliateOffer[]>(baseUrl);
    }
    const separator = baseUrl.includes('?') ? '&' : '?';
    return doGet<AffiliateOffer[]>(`${baseUrl}${separator}${extra.join('&')}`);
  },
  get: (offerId: IdentifierDTO) => () => doGet(`/affiliate-offers/${offerId}`),
  create:
    () =>
    (data: any): Promise<IdentifierDTO> =>
      doPost('/affiliate-offers', data),
  update: (offerId: IdentifierDTO) => (data: any) => doPut(`/affiliate-offers/${offerId}`, data),
  delete: () => (offerId: IdentifierDTO) => doDelete(`/affiliate-offers/${offerId}`),
  reorder: () => (data: { _id: IdentifierDTO; order: number }) =>
    doPut(`/affiliate-offers/${data._id}/reorder`, { order: data.order }),
  uploadLogo: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/logo`, formData),
  uploadImage: (offerId: IdentifierDTO) => (formData: FormData) =>
    doPostFileUpload(`/affiliate-offers/${offerId}/image`, formData)
};
